import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userHabitLogsAdapter = createEntityAdapter({})

const initialState = userHabitLogsAdapter.getInitialState()

export const userHabitLogsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserHabitLogs: builder.query({
            query: () => ({
                url: '/userHabitLogs/getUserHabitLogs',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserHabitLogs = responseData.map(userHabitLog => {
                    userHabitLog.id = userHabitLog._id
                    return userHabitLog
                })
                return userHabitLogsAdapter.setAll(initialState, loadedUserHabitLogs)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserHabitLog', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserHabitLog', id}))
                    ]
                } else {
                    return [ { type: 'UserHabitLog', id: 'LIST'}]
                }
            },
        }),
        createNewUserHabitLog: builder.mutation({
            query: initialUserHabitLog => ({
                url: '/userHabitLogs/createNewUserHabitLog',
                method: 'POST',
                body: {...initialUserHabitLog,}
            }),
            invalidatesTags: [
                { type: 'UserHabitLog', id: "LIST" }
            ] 
        }),
        updateUserHabitLog: builder.mutation({
            query: initialUserHabitLog => ({
                url: '/userHabitLogs/updateUserHabitLog',
                method: 'PATCH',
                body: {...initialUserHabitLog,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserHabitLog', id: arg.id },
                { type: 'UserHabitLog', id: 'LIST' }
            ],
        }),
        deleteUserHabitLog: builder.mutation({
            query: ({ id }) => ({
              url: '/userHabitLogs/deleteUserHabitLog',
              method: 'DELETE',
              body: {id },  
            }),
            invalidatesTags: (result, error, arg) => [
              { type: 'UserHabitLog', id: arg.id }
            ],
          }), 
        //   deleteHabit: builder.mutation({
        //     query: ({ id }) => ({
        //       url: '/habits/deleteHabit',
        //       method: 'DELETE',
        //       body: { id },  // Send both `habitId` and `userId`
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //       { type: 'Habit', id: arg.id }
        //     ],
        //   }),             
    }),
})

export const {
    useGetUserHabitLogsQuery,
    useCreateNewUserHabitLogMutation,
    useUpdateUserHabitLogMutation,
    useDeleteUserHabitLogMutation,
} = userHabitLogsApiSlice

// returns the query result object
export const selectUserHabitLogResult = userHabitLogsApiSlice.endpoints.getUserHabitLogs.select()

// create memoized selector
const selectUserHabitLogsData = createSelector(
    selectUserHabitLogResult,
    userHabitLogResult => userHabitLogResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserHabitLogs,
    selectById: selectUserHabitLogById,
    selectIds: selectUserHabitLogIds,
} = userHabitLogsAdapter.getSelectors(state => selectUserHabitLogsData(state) ?? initialState)